import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { OFFERS } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

export const Offerings = () => {
  const navigate = useNavigate();

  const go = (to) => {
    if (to.includes("#")) navigate("/", { state: { scrollTo: to.split("#")[1] } });
    else navigate(to);
  };

  return (
    <section id="accompagnements" className="scroll-mt-20 py-24 lg:py-36" data-testid="section-accompagnements">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
        <Reveal>
          <Eyebrow>Accompagnements & formation</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-3xl font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl">
            Vous avez le projet. Nous vous aidons à le concrétiser.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {OFFERS.map((offer, i) => (
            <Reveal key={offer.id} delay={i * 0.1} className="h-full">
              <article
                data-testid={`offer-card-${offer.id}`}
                className={`flex h-full flex-col border p-8 transition-colors duration-300 lg:p-10 ${
                  offer.featured ? "border-neon/60 bg-gradient-to-b from-card to-[#1D1327]" : "border-white/10 bg-[#1D1327] hover:border-white/25"
                }`}
              >
                <p className="font-mono text-xs text-neon">{offer.index}</p>
                <h3 className="mt-6 font-serif text-3xl text-cream lg:text-4xl">{offer.name}</h3>
                <p className="mt-6 flex-1 text-sm leading-relaxed text-white/60 sm:text-base">{offer.description}</p>
                {offer.details.length > 0 && (
                  <ul className="mt-8 flex flex-wrap gap-2">
                    {offer.details.map((d) => (
                      <li key={d} className="border border-white/10 px-3 py-1.5 font-mono text-[9px] uppercase tracking-[0.15em] text-white/55">
                        {d}
                      </li>
                    ))}
                  </ul>
                )}
                <button
                  onClick={() => go(offer.to)}
                  data-testid={`offer-cta-${offer.id}`}
                  className={`mt-10 inline-flex items-center justify-between gap-3 px-6 py-4 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors ${
                    offer.featured ? "bg-neon text-ink hover:bg-neon-light" : "border border-white/25 text-cream hover:border-neon hover:text-neon-light"
                  }`}
                >
                  {offer.cta} <ArrowRight className="h-4 w-4" />
                </button>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 text-sm text-white/40">
            Chaque accompagnement est construit sur mesure après un premier échange autour de votre projet.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
